import React from 'react'

import { Box, Typography } from "@mui/material"

export default function labelColumn(label) {

	return {
		name: 'name',
		label,
		render: value => <Box>
			<Typography>{value}</Typography>
		</Box>,
	}
}